import { useContext } from 'react';
import DropdownContext from '../contexts/dropdown.context';

const useDropdownContext = () => useContext(DropdownContext);

export default useDropdownContext;
